export const PROD_CONSTANTS = {
  SERVER_URL: 'https://api.trusted-rental.com.tw',
}; 